import React, { useState } from "react";
import { X } from "lucide-react";
import { BASE_URL } from "utils/constant";

const UpdateVendorModal = ({ vendor, onClose, onUpdate }) => {
  const [formData, setFormData] = useState({
    name: vendor?.name || "",
    contact_no: vendor?.contact_no || "",
    address: vendor?.address || "",
    vendor_type: vendor?.vendor_type || "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async () => {
    setLoading(true);
    setError("");

    try {
      const accessToken = localStorage.getItem("access");
      
      const response = await fetch(
        `${BASE_URL}/inventory/update-vendor/${vendor.id}/`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
          body: JSON.stringify(formData),
        }
      );

      const data = await response.json();

      if (response.ok && data.status) {
        onUpdate(); // Callback to refresh vendor data
        onClose();
      } else {
        setError(data.message || "Failed to update vendor");
      }
    } catch (err) {
      setError("An error occurred while updating vendor");
      console.error("Error updating vendor:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md mx-4">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <h2 className="text-xl font-semibold text-[#232323]">
            Update Vendor
          </h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Form Content */}
        <div className="p-6">
          {error && (
            <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg text-red-600 text-sm">
              {error}
            </div>
          )}

          <div className="space-y-4">
            {/* Vendor Name */}
            <div>
              <label
                htmlFor="name"
                className="block text-sm font-medium text-[#232323] mb-1"
              >
                Vendor Name <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#3B0069] focus:border-transparent"
                placeholder="Enter vendor name"
              />
            </div>

            {/* Contact Number */}
            <div>
              <label
                htmlFor="contact_no"
                className="block text-sm font-medium text-[#232323] mb-1"
              >
                Contact Number <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                id="contact_no"
                name="contact_no"
                value={formData.contact_no}
                onChange={handleChange}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#3B0069] focus:border-transparent"
                placeholder="Enter contact number"
              />
            </div>

            {/* Vendor Type */}
            <div>
              <label
                htmlFor="vendor_type"
                className="block text-sm font-medium text-[#232323] mb-1"
              >
                Vendor Type <span className="text-red-500">*</span>
              </label>
              <input
                type="text"
                id="vendor_type"
                name="vendor_type"
                value={formData.vendor_type}
                onChange={handleChange}
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#3B0069] focus:border-transparent"
                placeholder="Enter vendor type"
              />
            </div>

            {/* Address */}
            <div>
              <label
                htmlFor="address"
                className="block text-sm font-medium text-[#232323] mb-1"
              >
                Address <span className="text-red-500">*</span>
              </label>
              <textarea
                id="address"
                name="address"
                value={formData.address}
                onChange={handleChange}
                rows="3"
                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-[#3B0069] focus:border-transparent resize-none"
                placeholder="Enter vendor address"
              />
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex gap-3 mt-6">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors"
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={handleSubmit}
              disabled={loading}
              className="flex-1 px-4 py-2 bg-[#3B0069] text-white rounded-lg hover:bg-purple-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? "Updating..." : "Update Vendor"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UpdateVendorModal;